import angular from 'angular';
import uiRouter from 'angular-ui-router';
import targetdrgsComponent from './targetdrgs.component';

let targetdrgsModule = angular.module('targetdrgs', [
  uiRouter
])

.component('targetdrgs', targetdrgsComponent);

export default targetdrgsModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/targetdrgs/targetdrgs.js